import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BookingHistoryCriteria, BookingHistoryItem } from '../models';
import { AllocationViewEndpoint } from '../../allocation-view/constants';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class BookingHistoryService {
  constructor(private http: WrapperHttpService) {}

  getBookingHistoryArray(criteria: BookingHistoryCriteria): Observable<BookingHistoryItem[]> {
    const url = `${API_URL}${AllocationViewEndpoint.History}${AllocationViewEndpoint.Base}?${getQueryStringFromObject(
      criteria,
    )}`;

    return this.http.get<BookingHistoryItem[]>(url);
  }

  getConfirmationPDF(params: BookingHistoryCriteria): Observable<HttpResponse<Blob>> {
    const { uliType, compartmentId, uli } = params;
    const url = `${API_URL}${AllocationViewEndpoint.Base}/${uli}${
      AllocationViewEndpoint.Confirmation
    }?${getQueryStringFromObject({ compartmentId, uliType })}`;

    return this.http.get<HttpResponse<Blob>>(url, {
      responseType: 'blob',
      observe: 'response',
    });
  }
}
